<div class="c-payment-details-breakdown-item">
  <div class="c-payment-details-breakdown-item_titleblock">
    <!--搭乗者姓名-->
    <div class="c-payment-details-breakdown-item_titleblock_title">
      {{ data.dispName }}
    </div>
    <!-- 搭乗者種別 -->
    <div [ngSwitch]="data.ptc" class="c-payment-details-breakdown-item_titleblock_subtitle">
      <span *ngSwitchCase="'ADT'" [innerHTML]="'label.adult' | staticMsg"></span>
      <span *ngSwitchCase="'B15'" [innerHTML]="'label.youngAdult' | staticMsg"></span>
      <span *ngSwitchCase="'CHD'" [innerHTML]="'label.child' | staticMsg"></span>
      <span *ngSwitchCase="'INF'" [innerHTML]="'label.infant' | staticMsg"></span>
    </div>
  </div>
  <!--運賃 -->
  <div class="c-payment-details-breakdown-item_items">
    <div class="c-payment-details-breakdown-item_items_title">
      <div [innerHTML]="'label.fare' | staticMsg"></div>
      <div>
        <span
          *ngIf="!isCanada"
          class="not-bold"
          [innerHTML]="data.unitTicketBase | amountFormat : undefined : data.currencyCode"
        ></span>
      </div>
    </div>
    <div *ngIf="isCanada" class="c-payment-details-breakdown-item_items_content">
      <!-- 運賃(フライトサーチャージ) -->
      <div class="c-payment-details-breakdown-item_items_content_title">
        <!-- フライトサーチャージが存在する場合 -->
        <span *ngIf="data.flightSurcharge" [innerHTML]="'lable.fareAndVariousCharge' | staticMsg"></span>
        <!-- フライトサーチャージが存在しない場合 -->
        <span *ngIf="!data.flightSurcharge" [innerHTML]="'label.fare' | staticMsg"></span>
      </div>
      <div class="align-right">
        <span [innerHTML]="data.unitTicketBase | amountFormat : undefined : data.currencyCode"></span>
        <ng-container *ngIf="data.flightSurcharge">
          <br />
          <span
            [innerHTML]="
              'label.parenthesis.n'
                | staticMsg : { '0': data.flightSurcharge | amountFormat : undefined : data.currencyCode }
            "
          ></span>
        </ng-container>
      </div>
    </div>
    <div *ngIf="isCanada && data.fuelSurcharge" class="c-payment-details-breakdown-item_items_content">
      <!-- 燃油特別付加運賃 -->
      <div class="c-payment-details-breakdown-item_items_content_title">
        <!-- マスタから見出し取得 -->
        {{ mTaxMsgs['fuelSurcharge'] }}
      </div>
      <div [innerHTML]="data.fuelSurcharge | amountFormat : undefined : data.currencyCode"></div>
    </div>
    <div *ngIf="isCanada && data.insuranceSurcharge" class="c-payment-details-breakdown-item_items_content">
      <!-- 航空保険料 -->
      <div class="c-payment-details-breakdown-item_items_content_title">
        <!-- マスタから見出し取得 -->
        {{ mTaxMsgs['insuranceSurcharge'] }}
      </div>
      <div [innerHTML]="data.insuranceSurcharge | amountFormat : undefined : data.currencyCode"></div>
    </div>
  </div>
  <!--税金・料金等詳細 -->
  <div class="c-payment-details-breakdown-item_items">
    <div class="c-payment-details-breakdown-item_items_title">
      <div [innerHTML]="'label.totalTax' | staticMsg"></div>
    </div>
    <!-- 各国諸税 -->
    <div *ngFor="let tax of taxesPerCountry" class="c-payment-details-breakdown-item_items_content">
      <div class="c-payment-details-breakdown-item_items_content_title" [innerHTML]="tax.name"></div>
      <div [innerHTML]="tax.value | amountFormat : undefined : data.currencyCode"></div>
    </div>
    <!-- 燃油特別付加運賃 -->
    <div *ngIf="!isCanada && data.fuelSurcharge > 0" class="c-payment-details-breakdown-item_items_content">
      <div class="c-payment-details-breakdown-item_items_content_title">
        <!-- マスタから見出し取得 -->
        {{ mTaxMsgs['fuelSurcharge'] }}
      </div>
      <div [innerHTML]="data.fuelSurcharge | amountFormat : undefined : data.currencyCode"></div>
    </div>
    <div
      *ngIf="!(isCanada || isMalaysia) && data.insuranceSurcharge > 0"
      class="c-payment-details-breakdown-item_items_content"
    >
      <!-- 航空保険料 -->
      <div class="c-payment-details-breakdown-item_items_content_title">
        <!-- マスタから見出し取得 -->
        {{ mTaxMsgs['insuranceSurcharge'] }}
      </div>
      <div [innerHTML]="data.insuranceSurcharge | amountFormat : undefined : data.currencyCode"></div>
    </div>
  </div>
  <!-- 発券手数料 -->
  <div *ngIf="!isCanada" class="c-payment-details-breakdown-item_items">
    <div class="c-payment-details-breakdown-item_items_title">
      <div [innerHTML]="'label.fee' | staticMsg"></div>
      <!-- ※固定値0を出力 -->
      <div>
        <span class="not-bold" [innerHTML]="0 | amountFormat : undefined : data.currencyCode"></span>
      </div>
    </div>
  </div>

  <!--Ancillaryサービス支払内訳（税抜） -->
  <div *ngIf="isAncillarySvcExists" class="c-payment-details-breakdown-item_items">
    <div class="c-payment-details-breakdown-item_items_title">
      <div [innerHTML]="'label.paidServiceCharges' | staticMsg"></div>
    </div>
    <!-- 事前追加手荷物 -->
    <div *ngIf="data.firstBaggageValue" class="c-payment-details-breakdown-item_items_content">
      <div
        class="c-payment-details-breakdown-item_items_content_title"
        [innerHTML]="'label.extraBaggage' | staticMsg"
      ></div>
      <div [innerHTML]="data.firstBaggageValue | amountFormat : undefined : data.currencyCode"></div>
    </div>
    <!-- 有料ラウンジ -->
    <div *ngIf="data.loungeValue" class="c-payment-details-breakdown-item_items_content">
      <div
        class="c-payment-details-breakdown-item_items_content_title"
        [innerHTML]="'label.advancedLounge' | staticMsg"
      ></div>
      <div [innerHTML]="data.loungeValue | amountFormat : undefined : data.currencyCode"></div>
    </div>
    <!-- 有料機内食 -->
    <div *ngIf="data.mealValue" class="c-payment-details-breakdown-item_items_content">
      <div
        class="c-payment-details-breakdown-item_items_content_title"
        [innerHTML]="'label.chargeableMeal' | staticMsg"
      ></div>
      <div [innerHTML]="data.mealValue | amountFormat : undefined : data.currencyCode"></div>
    </div>
  </div>
  <!--Ancillaryサービス税額 -->
  <div *ngIf="ancillaryTaxes.length > 0" class="c-payment-details-breakdown-item_items last">
    <div class="c-payment-details-breakdown-item_items_title">
      <div [innerHTML]="'label.paidServiceTaxAmount' | staticMsg"></div>
    </div>
    <div *ngFor="let tax of ancillaryTaxes" class="c-payment-details-breakdown-item_items_content">
      <div class="c-payment-details-breakdown-item_items_content_title" [innerHTML]="tax.name"></div>
      <div [innerHTML]="tax.value | amountFormat : undefined : data.currencyCode"></div>
    </div>
  </div>
</div>
